// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2ouNF","radioRow":"SimpleQuestionBuilderModal_radioRow__2FPYH"};